import React, { useEffect } from "react";
import { useState } from "react";
import { DatePicker, Drawer, message } from "antd";
import dayjs from "dayjs";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import {
  createTraining,
  fetchAlltraininglist,
  updatetraining,
} from "../../core/data/redux/training/trainingAction";
import { AppDispatch } from "../data/redux/store";
import { getEmployees, getEmployeeByUserId } from "../data/redux/employee/employeeAction";
import { fetchAlltrainer } from "../../core/data/redux/training/trainer/trainerAction";
import { fetchAlltrainingtype } from "../../core/data/redux/training/trainertype/trainertypeAction";
import { filterByStatus } from "../utils/filterActiveData";
import moment from "moment";

interface TrainingListModalProps {
  isDrawerVisible: boolean;
  setIsDrawerVisible: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRowData: any;
  isEditing: boolean;
}

const TrainingListModal: React.FC<TrainingListModalProps> = ({
  selectedRowData,
  isEditing,
  isDrawerVisible,
  setIsDrawerVisible,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { employees } = useSelector((state: any) => state.employee);
  const [errors, setErrors] = useState<any>({});
  const { Training, loading } = useSelector((state: any) => state.training.training);
  const { trainingtype } = useSelector(
    (state: any) => state.training.trainingType
  );
  const { trainer } = useSelector((state: any) => state.training.trainer);
  const [selectedEmployees, setSelectedEmployees] = useState<
    { value: number; label: string }[]
  >([]);

  const daysOfWeek = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
  ];

  useEffect(() => {
    setErrors({});
    if (isEditing && selectedRowData) {
      setFormData({
        Name: selectedRowData?.Name || "",
        trainingType: selectedRowData?.Trainingtype || "",
        trainer: selectedRowData?.Trainer || "",
        Attendees: selectedRowData?.Attendees
          ? JSON.parse(selectedRowData.Attendees)
          : [],
        Mode: selectedRowData?.Mode || "",
        location: selectedRowData?.Location || "",
        trainingCost: selectedRowData?.Cost || "",
        StartDate: selectedRowData?.StartDate
          ? moment(selectedRowData.StartDate).format("YYYY-MM-DD HH:mm:ss")
          : "",
        EndDate: selectedRowData?.EndDate
          ? moment(selectedRowData.EndDate).format("YYYY-MM-DD HH:mm:ss")
          : "",

        Status: selectedRowData?.Status || "",
        Description: selectedRowData?.Description || "",
        createdBy: !isEditing ? user?.UserId || "" : "",
        modifiedBy: isEditing ? user?.UserId || "" : "",
        days: Array.isArray(selectedRowData?.RecurringDays) ? selectedRowData.RecurringDays : selectedRowData?.RecurringDays ? JSON.parse(selectedRowData.RecurringDays) : [],

      });
    } else {
      setFormData({
        Name: "",
        trainingType: "",
        trainer: "",
        Attendees: [],
        Mode: "",
        location: "",
        trainingCost: "",
        StartDate: "",
        EndDate: "",
        Status: "",
        Description: "",
        createdBy: user?.UserId || "",
        modifiedBy: user?.UserId || "",
        days: [],
      });
    }
  }, [isEditing, selectedRowData, employees, user]);



  const formattedTrainingtypes = trainingtype.map((emp: any) => ({
    value: emp.TrainingKey,
    label: emp.Type,
    status: emp.Status,
  }));

  const formattedTrainingtype = filterByStatus(formattedTrainingtypes, 'active', 'status');

  const formattedTrainers = trainer.map((emp: any) => ({
    value: emp.Id,
    label: emp.Name,
    status: emp.Status,
  }));

  const formattedTrainer = filterByStatus(formattedTrainers, 'active', 'status');

  const formattedEmployeess = employees.map((emp: any) => ({
    value: emp.EmployeeID,
    label: emp.Name,
    status: emp.employee_status,
  }));

  const formattedEmployees = filterByStatus(formattedEmployeess, 'active', 'status');

  const Status = [
    { value: "Select", label: "Select" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const mode = [
    { value: "Select", label: "Select" },
    { value: "Online", label: "Online" },
    { value: "Offline", label: "Offline" },
    { value: "Video", label: "Video Training" },
  ];


  const [formData, setFormData] = useState<{
    Name: string;
    trainingType: string;
    trainer: string;
    Attendees: number[];
    Mode: string;
    location: string;
    trainingCost: string;
    StartDate: string;
    EndDate: string;
    Status: string;
    Description: string;
    createdBy: string;
    modifiedBy: string;
    days: any;
  }>({
    Name: "",
    trainingType: "",
    trainer: "",
    Attendees: [],
    Mode: "",
    location: "",
    trainingCost: "",
    StartDate: "",
    EndDate: "",
    Status: "",
    Description: "",
    modifiedBy: user?.UserId,
    createdBy: user?.UserId,
    days: [],
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectionChange = (selectedOptions: any) => {
    setSelectedEmployees(selectedOptions);
    setFormData((prev) => ({
      ...prev,
      Attendees: selectedOptions.map((opt: any) => opt.value),
    }));
  };

  const handleDateChange = (date: any, field: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : null,
    }));
  };


  const validateForm = () => {
    let formIsValid = true;
    const newErrors: any = {};

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!formData.Name) {
      formIsValid = false;
      newErrors.Name = "Training name is required.";
    }
    if (!formData.trainingType) {
      formIsValid = false;
      newErrors.trainingType = "Training type is required.";
    }
    if (!formData.Attendees || formData.Attendees.length === 0) {
      formIsValid = false;
      newErrors.Attendees = "At least one attendee is required.";
    }
    if (!formData.Mode || formData.Mode === "Select") {
      formIsValid = false;
      newErrors.Mode = "Mode is required.";
    }
    if (!formData.trainer) {
      formIsValid = false;
      newErrors.trainer = "Trainer is required.";
    }
    if (!formData.trainingCost) {
      formIsValid = false;
      newErrors.trainingCost = "Training cost is required.";
    }
    if (!formData.StartDate) {
      formIsValid = false;
      newErrors.StartDate = "Start date is required.";
    } else {
      const startDate = new Date(formData.StartDate);
      if (startDate < today) {
        formIsValid = false;
        newErrors.StartDate = "Start date cannot be in the past.";
      }
    }

    if (!formData.EndDate) {
      formIsValid = false;
      newErrors.EndDate = "End date is required.";
    } else {
      const endDate = new Date(formData.EndDate);
      const startDate = new Date(formData.StartDate);
      if (endDate < today) {
        formIsValid = false;
        newErrors.EndDate = "End date cannot be in the past.";
      }
      if (formData.StartDate && endDate < startDate) {
        formIsValid = false;
        newErrors.EndDate = "End date cannot be before start date.";
      }
    }

    if (!formData.Status || formData.Status === "Select") {
      formIsValid = false;
      newErrors.Status = "Status is required.";
    }


    setErrors(newErrors);
    return formIsValid;
  };




  const handleSubmit = () => {


    if (!validateForm()) {
      return;
    }

    if (selectedRowData) {
      dispatch(updatetraining({ id: selectedRowData.Id, data: formData }))
        .then((resp) => {
          if (resp.meta.requestStatus === "fulfilled") {
            message.success("Training updated successfully");
            setIsDrawerVisible(false)
          } else {
            message.warning(resp.payload.error);

          }
        })
        .catch((error) => {
          console.error("Error updating training:", error);
        });
    } else {
      dispatch(createTraining(formData))
        .then((resp) => {
          if (resp.meta.requestStatus === "fulfilled") {
            message.success("Training added successfully");
            setFormData({
              Name: "",
              trainingType: "",
              trainer: "",
              Attendees: [],
              Mode: "",
              location: "",
              trainingCost: "",
              StartDate: "",
              EndDate: "",
              Status: "",
              Description: "",
              createdBy: user?.UserId || "",
              modifiedBy: user?.UserId || "",
              days: []
            });
            setIsDrawerVisible(false)
          } else {
            message.warning("Error adding training");
          }
        })
        .catch((error) => {
          console.error("Error adding training:", error);
        });
    }
  };

  useEffect(() => {
    dispatch(fetchAlltrainer());
    dispatch(getEmployees());
    dispatch(fetchAlltrainingtype());
    dispatch(getEmployeeByUserId({ userId: user.UserId }))
      .then((res) => {
        console.log(res.payload.data, 'data we get ......')
      })
  }, []);

  return (
    <>
      <Drawer
        title={isEditing ? "Update Training" : "Add Training"}
        placement="right"
        closable={true}
        onClose={() => setIsDrawerVisible(false)}
        open={isDrawerVisible}
        width={720}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Name <span className="text-danger"> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                  />
                  {errors.Name && <div style={{ color: "red" }}>{errors.Name}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Training Type <span className="text-danger"> *</span></label>
                  <Select
                    className="select"
                    options={formattedTrainingtype.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    value={formattedTrainingtype.find(
                      (option: any) =>
                        String(option.value) === String(formData.trainingType)
                    )}
                    onChange={(selected: any) =>
                      setFormData((prev) => ({
                        ...prev,
                        trainingType: selected.value,
                      }))
                    }
                  />
                  {errors.trainingType && <div style={{ color: "red" }}>{errors.trainingType}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Trainer <span className="text-danger"> *</span></label>
                  <Select
                    className="select"
                    options={formattedTrainer.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    value={formattedTrainer.find(
                      (option: any) =>
                        String(option.value) === String(formData.trainer)
                    )}
                    onChange={(selected: any) =>
                      setFormData((prev) => ({
                        ...prev,
                        trainer: selected.value,
                      }))
                    }
                  />
                  {errors.trainer && <div style={{ color: "red" }}>{errors.trainer}</div>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Attendees <span className="text-danger"> *</span></label>
                  <Select
                    isMulti
                    options={formattedEmployees.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    value={formattedEmployees.filter((emp: any) =>
                      formData.Attendees.includes(emp.value)
                    )}
                    onChange={handleSelectionChange}
                    placeholder="Select attendees..."
                    styles={{
                      multiValue: (base: any) => ({
                        ...base,
                        display: "inline-flex",
                        marginRight: "5px",
                      }),
                      multiValueLabel: (base: any) => ({
                        ...base,
                        whiteSpace: "nowrap",
                      }),
                      control: (base: any, state: any) => ({
                        ...base,
                        minHeight: "38px",
                        overflow: "auto",
                        flexWrap: "nowrap",
                        borderColor: "#ced4da",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: "#ced4da",
                        },
                      }),
                    }}
                  />
                  {errors.Attendees && <div style={{ color: "red" }}>{errors.Attendees}</div>}
                </div>
              </div>

              {/* Mode */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Mode <span className="text-danger"> *</span></label>
                  <select
                    className="form-control"
                    name="Mode"
                    value={formData.Mode}
                    onChange={handleChange}
                  >
                    {mode.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {errors.Mode && <div style={{ color: "red" }}>{errors.Mode}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Recurring
                  </label>

                  <Select
                    isMulti
                    placeholder="Select days"
                    options={daysOfWeek}
                    value={daysOfWeek.filter((day) => formData.days.includes(day.value))}
                    onChange={(selectedOptions: any) =>
                      setFormData((prev) => ({
                        ...prev,
                        days: selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [],
                      }))
                    }
                  />

                </div>
              </div>


              {/* Location */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Location/URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                  />
                  {errors.location && <div style={{ color: "red" }}>{errors.location}</div>}
                </div>
              </div>

              {/* Training Cost */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Training Cost <span className="text-danger"> *</span></label>
                  <input
                    type="number"
                    className="form-control"
                    name="trainingCost"
                    value={formData.trainingCost}
                    onChange={handleChange}
                  />
                  {errors.trainingCost && <div style={{ color: "red" }}>{errors.trainingCost}</div>}
                </div>
              </div>


              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Start Date & Time <span className="text-danger"> *</span></label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      className="form-control datetimepicker"
                      showTime={{ format: "HH:mm" }}
                      format="YYYY-MM-DD HH:mm"
                      value={
                        formData.StartDate ? dayjs(formData.StartDate) : null
                      }
                      onChange={(date) =>
                        handleDateChange(date, "StartDate")
                      }
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                  {errors.StartDate && (
                    <div style={{ color: "red" }}>{errors.StartDate}</div>
                  )}
                </div>
              </div>


              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">End Date & Time <span className="text-danger"> *</span></label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      className="form-control datetimepicker"
                      showTime={{ format: "HH:mm" }}
                      format="YYYY-MM-DD HH:mm"
                      value={
                        formData.EndDate ? dayjs(formData.EndDate) : null
                      }
                      onChange={(date) =>
                        handleDateChange(date, "EndDate")
                      }
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                  {errors.EndDate && (
                    <div style={{ color: "red" }}>{errors.EndDate}</div>
                  )}
                </div>
              </div>
              {/* Status */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Status <span className="text-danger"> *</span></label>
                  <Select
                    className="select"
                    options={Status}
                    value={Status.find(
                      (option) => option.value === formData.Status
                    )}
                    onChange={(selected: any) =>
                      setFormData((prev) => ({
                        ...prev,
                        Status: selected.value,
                      }))
                    }
                  />
                  {errors.Status && <div style={{ color: "red" }}>{errors.Status}</div>}
                </div>
              </div>
              {/* Description */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Description </label>
                  <textarea
                    className="form-control"
                    name="Description"
                    value={formData.Description}
                    onChange={handleChange}
                  />
                  {errors.Description && <div style={{ color: "red" }}>{errors.Description}</div>}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setIsDrawerVisible(false)}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
              {loading ? (<>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"  >
                </span> {isEditing ? "Updating..." : "Adding..."}    </>) : (
                isEditing ? "Update Training" : "Add Training"
              )}
            </button>

          </div>
        </form>
      </Drawer>
      {/* /Add Training */}
      {/* Edit Training */}

      {/* /Edit Training */}
    </>
  );
};

export default TrainingListModal;
